var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.actions.length
        ? _c(
            "el-popover",
            {
              attrs: {
                placement: "top",
                trigger: "hover",
                "popper-class": "p-0 ov-hidden"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "reference",
                    fn: function() {
                      return [
                        _c("CompassButton", {
                          attrs: {
                            label: _vm.mainAction.label,
                            type: "secondary",
                            dropdown: ""
                          },
                          on: { click: _vm.mainAction.action }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                271225643
              ),
              model: {
                value: _vm.visible,
                callback: function($$v) {
                  _vm.visible = $$v
                },
                expression: "visible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex-column" },
                _vm._l(_vm.actions, function(action, index) {
                  return _c("CompassLink", {
                    key: index,
                    staticClass: "wp-10 my-2",
                    class: {
                      "mt-2": index === 0,
                      "mb-2": index === _vm.actions.length - 1
                    },
                    attrs: { label: action.label, type: "secondary" },
                    on: { click: action.action }
                  })
                }),
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }